import '../styles/app.scss';
import './_images';
import './_fonts';

import CustomFieldsRepeater from './components/CustomFieldsRepeaters.js';
import MyAccount from "./components/MyAccount";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');

		new CustomFieldsRepeater();
		new MyAccount();
	},
	false
);
